import React, { forwardRef, useImperativeHandle , useRef} from "react";
import './InputStyles.css';

const TextArea = forwardRef((props, ref) => {
    const inputRef = useRef(ref);

    useImperativeHandle(ref, () => ({
        focus: () => {
            inputRef.current.focus();
        }
    }));

    return <div className="inputBox colBlock nopdng">
            <textarea placeholder={props.placeholder} type={props.type} value={props.value} onChange={props.onChange} maxlength={props.maxLength}  ref={inputRef}/>
            <label>{props.label}</label>
            {props.error && <span className="inputErrorMsg">{props.errorMsg}</span>}
        </div>
})
export default TextArea;

// placeholder="placeholder"
// type="text"
// onChange=""
// label="name"